module.exports = require("./ar-SS.js");